<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>核銷單備存</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>預算分配</span></li>
          <li><span>核銷單備存</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="left">
              <div>查詢類別:
                <select v-model="search.fileType">
                  <option :value="null">請選擇</option>
                  <option :value="1">生活助學金</option>
                  <option :value="2">工讀金(本薪)</option>
                  <option :value="3">工讀金(勞退)</option>
                  <option :value="4">契約書</option>
                </select>　
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body" align="left">
              <div align="left">
                選擇上傳檔案 :
                <select v-model="form.fileType">
                  <option :value="null" selected>請選擇</option>
                  <option :value="1">生活助學金</option>
                  <option :value="2">工讀金(本薪)</option>
                  <option :value="3">工讀金(勞退)</option>
                  <option :value="4">契約書</option>
                </select>　<input type="file" ref="file" style="display: inline; max-width: 180px;"> (限PDF檔)
                <a href="#" @click.prevent="fileUpload" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">上傳</a>
              </div><br>

              <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                <thead>
                  <tr>
                    <th class="text-center" width="10%">刪除</th>
                    <th class="text-center" width="10%">序號</th>
                    <th class="text-center" width="20%">上傳類別</th>
                    <th class="text-center" width="20%">備份記錄</th>
                    <th class="text-center" width="20%">上傳日期</th>
                    <th class="text-center" width="20%">上傳帳號</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td data-title="刪除" class="text-center">
                      <a href="#" @click.prevent="delData(item.id)">刪除</a>
                    </td>
                    <td data-title="序號" class="text-center">{{index + 1}}</td>
                    <td data-title="上傳類別" class="text-center">{{item.fileType}}</td>
                    <td data-title="備份記錄" class="text-center">
                      <a :href="item.filePath" target="_blank">{{item.fileName}}</a>
                    </td>
                    <td data-title="上傳日期" class="text-center">{{item.createDate}}</td>
                    <td data-title="上傳帳號" class="text-center">{{item.createUser}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      search: {
        fileType: null
      },
      form:{
        fileType: null
      },
      list: []
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table).DataTable().destroy();
      }
      this.$http
        .get("/api/verification/backup", { params: { fileType: this.search.fileType } })
        .then(a => {
          this.list = a.body;
          this.$nextTick(b => {
            $(this.$refs.table).DataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁"
              },
              columnDefs: [
                {
                  targets: 0,
                  orderable: false,
                },
                {
                  targets: 1,
                  orderable: false,
                }
              ],
              order: [2, "desc"],
              columns: [
                { width: "8%" },
                { width: "12%" },
                { width: "20%" },
                { width: "20%" },
                { width: "20%" },
                { width: "20%" }
              ]
            });
          });
        });
    },
    searchClear() {
      this.search.fileType = null;
    },
    searchSubmit() {
      this.load();
    },
    fileUpload() {
      if (!this.form.fileType) {
        alert("請選擇上傳檔案類型");
        return false;
      }
      let file = this.$refs.file.files[0];
      if (!file) {
        alert("尚未選擇上傳檔案");
        return false;
      }
      if (file.type !== "application/pdf") {
        alert("請上傳PDF檔(.pdf)");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("fileType", this.form.fileType);
      this.$http
        .post("/api/verification/backup", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(a => {
          if (a.body.status) {
            alert("上傳成功");
            this.$refs.file.value = '';
            this.form.fileType = null;
            this.load();
          } else {
            alert("上傳失敗:" + a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    delData(id) {
      if (!confirm("您的動作將會刪除此筆核銷單備存資料。\n請問是否確認要刪除？")) return false;
      this.$http.delete("/api/verification/backup/" + id).then(a => {
          if (a.body.status) {
            alert("刪除成功");
            this.load();
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
      });
    }
  }
};
</script>

<style>
</style>